export default {
      id: "check-usage",
      viewBox: "0 0 19 15",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#check",
      toString: function () {
        return this.url;
      }
    }